/* SK Delivery - Selector global de fecha de entrega (cart + drawer).
   Lee max_prep_days del carrito, calcula fechas validas, bloquea anteriores al minimo,
   guarda la fecha como cart.attributes['Fecha de entrega']. */
(function () {
  'use strict';

  var ATTR_KEY = 'Fecha de entrega';
  var DIAS = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  /* Estado a nivel modulo: compartido entre TODAS las instancias del picker (mobile/desktop/drawer).
     Evita que cada picker haga su propia peticion cuando se cambia la fecha en uno. */
  var _lastSaved = null;     /* Ultima fecha enviada al servidor (string "Viernes 01 mayo") */
  var _savePending = false;  /* Hay una peticion en curso? */
  var _pickers = [];         /* Registro de initDelivery contexts, para actualizar UI en broadcast */

  function initDelivery(root) {
    /* R45: guard */
    if (root.dataset.skInit) return;
    root.dataset.skInit = 'true';

    var prefix = root.dataset.prefix || 'cart';
    var maxPrepDays = parseInt(root.dataset.maxPrepDays, 10) || 2;
    var blockerProduct = root.dataset.blockerProduct || '';
    var currentAttrDate = root.dataset.currentDate || '';
    var cutoff = root.dataset.cutoff || '14:00';
    var allowSat = root.dataset.saturday === 'true';
    var allowSun = root.dataset.sunday === 'true';
    var optionsCount = parseInt(root.dataset.optionsCount, 10) || 6;
    var label = root.dataset.label || 'Entrega el';

    var toggle = root.querySelector('.sk-delivery__toggle');
    var display = root.querySelector('[data-sk-delivery-display]');
    var panel = root.querySelector('.sk-delivery__panel');
    var options = root.querySelector('[data-sk-delivery-options]');
    var cancelBtn = root.querySelector('[data-sk-delivery-cancel]');
    var blocker = root.querySelector('[data-sk-delivery-blocker]');
    var blockerText = root.querySelector('[data-sk-delivery-blocker-text]');
    var blockerClose = root.querySelectorAll('[data-sk-delivery-blocker-close]');
    var toast = root.querySelector('[data-sk-delivery-toast]');

    /* ======================================================
       Calculo de fechas
       ====================================================== */

    function isPastCutoff() {
      var now = new Date();
      var parts = cutoff.split(':');
      var h = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10) || 0;
      return now.getHours() > h || (now.getHours() === h && now.getMinutes() >= m);
    }

    function isBusinessDay(d) {
      var day = d.getDay();
      return day >= 1 && day <= 5;
    }

    function isDeliveryDay(d) {
      var day = d.getDay();
      if (day >= 1 && day <= 5) return true;
      if (day === 6 && allowSat) return true;
      if (day === 0 && allowSun) return true;
      return false;
    }

    function addBusinessDays(start, n) {
      var d = new Date(start);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (isBusinessDay(d)) added++;
      }
      return d;
    }

    function formatDate(d) {
      var name = DIAS[d.getDay()];
      var num = ('0' + d.getDate()).slice(-2);
      var mes = MESES[d.getMonth()];
      return name.charAt(0).toUpperCase() + name.slice(1) + ' ' + num + ' ' + mes;
    }

    /* YYYY-MM-DD en LOCAL (evita el bug de toISOString que usa UTC y desfasa un dia). */
    function toLocalISO(d) {
      var y = d.getFullYear();
      var m = ('0' + (d.getMonth() + 1)).slice(-2);
      var day = ('0' + d.getDate()).slice(-2);
      return y + '-' + m + '-' + day;
    }

    function isTomorrow(d) {
      var t = new Date();
      t.setDate(t.getDate() + 1);
      return d.getDate() === t.getDate() && d.getMonth() === t.getMonth() && d.getFullYear() === t.getFullYear();
    }

    /* Base desde hoy + cutoff + siguiente laborable */
    function getBaseDate() {
      var base = new Date();
      base = new Date(base.getFullYear(), base.getMonth(), base.getDate());
      if (isPastCutoff()) base.setDate(base.getDate() + 1);
      while (!isBusinessDay(base)) base.setDate(base.getDate() + 1);
      return base;
    }

    /* Calcula las N fechas:
       - Empieza SIEMPRE desde prep=2 (minimo razonable, para que se vean tambien las anteriores al blocker como disabled)
       - Si maxPrepDays > 2, las fechas anteriores al "min valido" quedan disabled
    */
    function calcDates() {
      var base = getBaseDate();
      /* Empezamos desde +2 laborables (default minimo). Asi el usuario ve tambien las "bloqueadas". */
      var startPrep = Math.min(2, maxPrepDays);
      var start = addBusinessDays(base, startPrep);

      /* Fecha minima valida = base + maxPrepDays */
      var minValid = addBusinessDays(base, maxPrepDays);

      var dates = [];
      var d = new Date(start);
      if (isDeliveryDay(d)) dates.push(new Date(d));
      while (dates.length < optionsCount) {
        d.setDate(d.getDate() + 1);
        if (isDeliveryDay(d)) dates.push(new Date(d));
      }

      return { dates: dates, minValid: minValid };
    }

    /* ======================================================
       Render de radios
       ====================================================== */

    function render() {
      var result = calcDates();
      var dates = result.dates;
      var minValid = result.minValid;

      var html = '';
      var defaultDate = null;

      /* Si hay una fecha ya guardada en cart.attributes y sigue siendo valida (>= minValid), usarla.
         Si es anterior, auto-bump a minValid + toast. */
      var attrDate = parseAttrDate(currentAttrDate);
      if (attrDate) {
        if (attrDate < minValid) {
          /* auto-bump */
          attrDate = minValid;
          scheduleToast('La fecha se actualizo por un producto con mayor preparacion');
        }
      }

      for (var i = 0; i < dates.length; i++) {
        var d = dates[i];
        var isDisabled = d < minValid;
        var fmt = formatDate(d);
        var isoDate = toLocalISO(d); /* YYYY-MM-DD LOCAL (no UTC!) */

        /* Seleccion por defecto: attrDate si existe y coincide, sino la primera valida */
        var isSelected = false;
        if (attrDate) {
          if (d.getTime() === attrDate.getTime()) isSelected = true;
        } else if (!isDisabled && !defaultDate) {
          isSelected = true;
          defaultDate = d;
        }

        html += '<label class="sk-delivery__option' + (isDisabled ? ' sk-delivery__option--disabled' : '') + '">';
        html += '<input class="sk-delivery__radio" type="radio" name="sk-delivery-' + prefix + '" value="' + isoDate + '"';
        if (isSelected) html += ' checked';
        if (isDisabled) html += ' data-disabled="true"';
        html += '>';
        html += '<span class="sk-delivery__check"></span>';
        html += '<span class="sk-delivery__date-text">' + fmt + '</span>';
        if (isDisabled) {
          html += '<span class="sk-delivery__lock" aria-hidden="true">';
          html += '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 5V4a3 3 0 116 0v1m-6 0h6v5H3V5z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          html += '</span>';
        }
        if (isTomorrow(d) && !isDisabled) {
          html += '<span class="sk-delivery__badge">Mañana</span>';
        }
        html += '</label>';
      }

      options.innerHTML = html;

      /* Actualizar display */
      var selected = attrDate || defaultDate;
      if (selected) {
        var fmtSel = formatDate(selected);
        if (display) display.textContent = label + ' ' + fmtSel.toLowerCase();

        /* Si la seleccion default es DISTINTA del attrDate actual, sincronizar con el cart */
        if (!attrDate || selected.getTime() !== (attrDate ? attrDate.getTime() : 0)) {
          saveAttribute(formatDate(selected));
        }
      }
    }

    function parseAttrDate(str) {
      if (!str) return null;
      /* attr puede estar en formato "Jueves 24 abril" (lo que guardamos) */
      var parts = str.toLowerCase().replace(/^(\S+)\s+/, '').split(' ');
      if (parts.length < 2) return null;
      var day = parseInt(parts[0], 10);
      var monthIdx = MESES.indexOf(parts[1]);
      if (isNaN(day) || monthIdx < 0) return null;
      var now = new Date();
      var year = now.getFullYear();
      /* Si el mes parseado es menor al actual, es del anio siguiente */
      if (monthIdx < now.getMonth()) year++;
      return new Date(year, monthIdx, day);
    }

    /* ======================================================
       Cart attribute (AJAX) - dedup a nivel de modulo
       ====================================================== */

    function saveAttribute(fmtDate) {
      /* Skip si ya es la ultima fecha guardada (o en cola) — evita 3 peticiones cuando
         hay 3 pickers en la pagina y todos intentan sincronizar */
      if (fmtDate === _lastSaved) return;
      if (_savePending) return;
      _savePending = true;
      _lastSaved = fmtDate;

      var body = { attributes: {} };
      body.attributes[ATTR_KEY] = fmtDate;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          _savePending = false;
          /* Avisar a las otras instancias del picker para que sincronicen su UI sin re-enviar */
          document.dispatchEvent(new CustomEvent('sk-delivery:saved', { detail: { date: fmtDate } }));
        })
        .catch(function () {
          _savePending = false;
          /* Rollback para reintento posterior */
          _lastSaved = null;
        });
    }

    /* Actualiza la UI de este picker sin tocar el cart (reaccion a un save de otro picker) */
    function syncUIFromBroadcast(fmtDate) {
      if (display) display.textContent = label + ' ' + fmtDate.toLowerCase();
      /* Marcar el radio correspondiente si esta en el DOM */
      var parsed = parseAttrDate(fmtDate);
      if (!parsed) return;
      var iso = (function (d) {
        var y = d.getFullYear();
        var m = ('0' + (d.getMonth() + 1)).slice(-2);
        var day = ('0' + d.getDate()).slice(-2);
        return y + '-' + m + '-' + day;
      })(parsed);
      var inputs = options.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === iso && inputs[i].dataset.disabled !== 'true') {
          inputs[i].checked = true;
          /* Limpiar was-checked en los otros y poner en este */
          for (var j = 0; j < inputs.length; j++) inputs[j].removeAttribute('data-was-checked');
          inputs[i].setAttribute('data-was-checked', 'true');
          break;
        }
      }
    }

    /* Registrar este contexto para recibir broadcasts */
    _pickers.push({ sync: syncUIFromBroadcast });

    /* ======================================================
       Toast (auto-bump notice)
       ====================================================== */

    var pendingToast = null;
    function scheduleToast(msg) {
      pendingToast = msg;
    }
    function flushToast() {
      if (!pendingToast || !toast) return;
      toast.textContent = pendingToast;
      toast.classList.add('sk-delivery__toast--visible');
      setTimeout(function () {
        toast.classList.remove('sk-delivery__toast--visible');
      }, 4000);
      pendingToast = null;
    }

    /* ======================================================
       Popup bloqueante
       ====================================================== */

    function showBlocker() {
      if (!blocker) return;
      var msg = 'No se puede entregar antes del ' + formatDate(calcDates().minValid).toLowerCase();
      if (blockerProduct) {
        msg += ' porque el producto "' + blockerProduct + '" necesita ' + maxPrepDays + ' dias laborables de preparacion.';
      } else {
        msg += '.';
      }
      msg += ' Puedes elegir esa fecha o cualquier dia posterior.';
      if (blockerText) blockerText.textContent = msg;
      blocker.setAttribute('aria-hidden', 'false');
      blocker.classList.add('sk-delivery__blocker--visible');
    }

    function hideBlocker() {
      if (!blocker) return;
      blocker.setAttribute('aria-hidden', 'true');
      blocker.classList.remove('sk-delivery__blocker--visible');
    }

    for (var b = 0; b < blockerClose.length; b++) {
      blockerClose[b].addEventListener('click', hideBlocker);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && blocker && blocker.classList.contains('sk-delivery__blocker--visible')) {
        hideBlocker();
      }
    });

    /* ======================================================
       Toggle panel
       ====================================================== */

    function openPanel() {
      if (!panel || !toggle) return;
      toggle.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      root.classList.add('sk-delivery--open');
      flushToast();
    }
    function closePanel() {
      if (!panel || !toggle) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0';
      root.classList.remove('sk-delivery--open');
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        if (open) closePanel(); else openPanel();
      });
    }
    if (cancelBtn) cancelBtn.addEventListener('click', closePanel);

    /* ======================================================
       Cambio de radio (select)
       ====================================================== */

    options.addEventListener('click', function (e) {
      var lbl = e.target.closest('.sk-delivery__option');
      if (!lbl) return;
      var radio = lbl.querySelector('input[type="radio"]');
      if (!radio) return;
      if (radio.dataset.disabled === 'true') {
        e.preventDefault();
        /* Impedir que el radio se marque */
        var checked = options.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < checked.length; i++) {
          if (checked[i].dataset.disabled !== 'true' && checked[i].hasAttribute('data-was-checked')) {
            checked[i].checked = true;
          }
        }
        showBlocker();
      }
    });

    options.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      if (e.target.dataset.disabled === 'true') {
        e.preventDefault();
        showBlocker();
        return;
      }
      /* Marcar el valor seleccionado para reconstruir si intentan pickear disabled despues */
      var inputs = options.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) inputs[i].removeAttribute('data-was-checked');
      e.target.setAttribute('data-was-checked', 'true');

      /* isoDate → format → display + save */
      var parts = e.target.value.split('-');
      var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      var fmt = formatDate(d);
      if (display) display.textContent = label + ' ' + fmt.toLowerCase();
      saveAttribute(fmt);
      closePanel();
    });

    /* Initial render */
    render();
  }

  function initAll(ctx) {
    var root = ctx || document;
    var elements = root.querySelectorAll('[data-sk-delivery]');
    for (var i = 0; i < elements.length; i++) initDelivery(elements[i]);
  }

  /* Broadcast: cuando un picker guarda la fecha, los demas actualizan su UI sin hacer otra peticion */
  document.addEventListener('sk-delivery:saved', function (e) {
    var date = e && e.detail && e.detail.date;
    if (!date) return;
    for (var i = 0; i < _pickers.length; i++) {
      try { _pickers[i].sync(date); } catch (err) {}
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* R48: re-init cuando Shopify recarga una seccion (carrito via AJAX) */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) initAll(e.target);
  });

  /* Re-init cuando se actualiza el carrito.
     Limpiamos el registro porque los contextos antiguos apuntan a DOM que ya no existe.
     El refresh real del drawer ocurre ~200ms despues (ver sk-cart-drawer-filled.js refreshDrawer).
     Usamos MutationObserver ademas para cubrir cualquier timing. */
  document.addEventListener('cart:update', function () {
    _pickers.length = 0;
    /* Intento inmediato + tardio por si el DOM ya esta listo o aun no */
    setTimeout(initAll, 50);
    setTimeout(initAll, 300);
    setTimeout(initAll, 600);
  });

  /* MutationObserver global: detecta cuando llega un picker nuevo (via morph/replace) */
  var _cartComponent = document.querySelector('cart-items-component');
  if (_cartComponent) {
    new MutationObserver(function () {
      var pickers = _cartComponent.querySelectorAll('[data-sk-delivery]');
      for (var i = 0; i < pickers.length; i++) {
        if (!pickers[i].dataset.skInit) {
          initDelivery(pickers[i]);
        }
      }
    }).observe(_cartComponent, { childList: true, subtree: true });
  }
})();
